
import Header from '../components/layout/Header';

const Reports = () => {
  return (
    <div className="h-full flex flex-col bg-gray-50">
      <Header title="Reports" subtitle="View system reports" />
      
      <div className="flex-1 p-8 animate-fade-in">
        <div className="bg-white rounded-lg shadow p-8 text-center">
          <h2 className="text-2xl font-medium text-gray-700 mb-4">Reports Page</h2>
          <p className="text-gray-500">This is the reports page.</p>
        </div>
      </div>
    </div>
  );
};

export default Reports;
